import { Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const generalRules = {
    required: {
        required: true,
        validator: (_rule, value: any) => {
            if (!value) {
                return Promise.reject(new Error(i18n.t("validation:required")))
            }
            return Promise.resolve()
        },
    } as Rule,
}
